export class ParserKeyError extends Error {
    constructor(parser, key) {
        const message = `${parser} can not parse the key '${key}'`;
        super(message);
        this.name = 'ParserKeyError';
    }
}
export class ParserAttributeError extends Error {
    constructor(attribute, value, msg) {
        const message = `${attribute} set to ${value}. ${msg}`;
        super(message);
        this.name = 'ParserAttributeError';
    }
}
